import { BaseModel } from '..';

const initialState: WorkpacksState = {
  workpacksMap: new Map(),
  lastFetched: 0,
  data: null,
  publicWorkpack: {},
};

export enum WorkpacksActionTypes {
  SAVE = 'workpacks/save',
  SAVE_ALL = 'workpacks/saveAll',
  SAVE_PUBLIC = 'workpacks/savePublic',
  DELETE = 'workpacks/delete',
}

interface SaveWorkpacksActionType {
  type: WorkpacksActionTypes.SAVE;
  payload: Workpack;
}

interface SaveAllWorkpacksActionType {
  type: WorkpacksActionTypes.SAVE_ALL;
  payload: Workpack;
}

interface SavePublicWorkpacksActionType {
  type: WorkpacksActionTypes.SAVE_PUBLIC;
  payload: Workpack;
}

interface DeleteWorkpacksActionType {
  type: WorkpacksActionTypes.DELETE;
  payload: { removeId };
}

type WorkpacksAction =
  | SaveWorkpacksActionType
  | SaveAllWorkpacksActionType
  | SavePublicWorkpacksActionType
  | DeleteWorkpacksActionType;

export default function(state = initialState, action: WorkpacksAction): WorkpacksState {
  switch (action.type) {
    case WorkpacksActionTypes.SAVE_ALL: {
      const workpacksMap = new Map(state.workpacksMap.entries());
      if (action.payload && Array.isArray(action.payload)) {
        action.payload.forEach((workpack) => {
          workpacksMap.set(workpack.id, {
            ...workpacksMap.get(workpack.id),
            ...workpack,
          });
        });
      }
      return {
        ...state,
        workpacksMap,
        lastFetched: Date.now(),
      };
    }
    case WorkpacksActionTypes.SAVE: {
      const workpacksMap = new Map(state.workpacksMap.entries());
      if (action.payload && action.payload.id) {
        workpacksMap.set(action.payload.id, {
          ...workpacksMap.get(action.payload.id),
          ...action.payload,
          lastFetched: Date.now(),
        });
      }
      return {
        ...state,
        workpacksMap,
      };
    }
    case WorkpacksActionTypes.SAVE_PUBLIC: {
      return {
        ...state,
        publicWorkpack: {
          ...action.payload,
          lastFetched: Date.now(),
        },
      };
    }
    case WorkpacksActionTypes.DELETE: {
      const workpacksMap = new Map(state.workpacksMap.entries());
      if (action.payload.removeId) {
        workpacksMap.delete(action.payload.removeId);
      }
      return {
        ...state,
        workpacksMap,
        lastFetched: Date.now(),
      };
    }
    default:
      return state;
  }
}

export interface WorkpacksState {
  workpacksMap: Map<string, Workpack>;
  lastFetched: number;
  data: Workpack;
  publicWorkpack: object;
}

export interface Workpack extends BaseModel {
  id: string;
  aircraft_id: string;
  po_number: string;
  reference: string;
  description: string;
  status: string;
  release_date: string;
  attachments: Array<any>;
  notes: string;
  date: string;
  workpack_items: {
    id: string;
    mx_item_id: string;
    mx_item: {
      type: string;
      id: string;
      draft: false;
      status: string;
      mx_type: string;
      last_updated: number;
      name: string;
      reference: unknown;
      ata_chapter: unknown;
      ata_number: unknown;
      assembly: unknown;
      repeat_remarks: unknown;
      date_due: unknown;
      flight_seconds_due: number;
      flight_seconds_tolerance: unknown;
      flight_seconds_repeat: unknown;
      flight_seconds_threshold: unknown;
      flight_seconds_remaining: number;
      apu_seconds_due: unknown;
      apu_seconds_tolerance: unknown;
      apu_seconds_repeat: unknown;
      apu_seconds_threshold: unknown;
      apu_seconds_remaining: unknown;
      cycles_due: unknown;
      cycles_tolerance: unknown;
      cycles_repeat: unknown;
      cycles_threshold: unknown;
      cycles_remaining: unknown;
      days_tolerance: unknown;
      days_threshold: unknown;
      days_remaining: unknown;
      mx_events?: Array<MXEvents>;
      months_repeat: unknown;
      months_tolerance: unknown;
      months_threshold: unknown;
      part_number: unknown;
      part_serial: unknown;
      estimated_date: string;
    };
  }[];
}

export interface MXEvents {
  date: string;
  description: string;
  id: string;
  limitations: string;
  part_changes: Array<any>;
  release: Release;
  work_type: any;
}

export interface Release {
  additional_items: Array<any>;
  approval_number: string;
  attachments: Array<any>;
  company_name: string;
  first_name: string;
  id: string;
  last_name: string;
  licence_number: string;
  reporter_first_name: string;
  reporter_last_name: string;
  signature: string;
  signature_statement: string;
}
